// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class InitDataRequestInstrumentsGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.INIT_DATA_REQUEST_INSTRUMENTS_GROUP, null, pfixFieldSet);
    }
}
